/* eslint-disable no-undef */

import { REGEX } from '../utils/regex';
import { getNumberOfDaysBetweenDates } from './../utils/date';
import {
    SUBSCRIBER,
    COMMON,
    VALIDATION_MESSAGE,
    PLUS_GUIDED_JOURNEY,
    LAWREADY,
    VENDOR
} from './../constants';
import { REDUX_CONSTANT } from '../constants';
import configuration from '../config.json';
import Route from '../route';
import configInstance from '../configSingleton';
import RoutePath from '../route';

const config = configInstance.getConfig();
/**
 *
 *
 * @param {string} configKey The config key
 */

export function convertToNumberByKey(configKey) {
    const configValue = config[configKey];
    if (
        configKey &&
        configKey !== null &&
        configKey !== undefined &&
        !isNaN(configValue)
    ) {
        return parseInt(configValue, 10);
    }
    return 0;
}

/**
 *
 *
 * @param {object} file The file data
 */
export function convertBlobToBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve) => {
        reader.onloadend = () => {
            resolve(reader.result.split(',')[1]);
        };
    });
}

/**
 *
 *
 * @param {string} base64 The data string
 */
export function convertBase64ToCsv(base64) {
    let csvContent = atob(base64);
    return new Blob([csvContent], {
        type: 'data:application/octet-stream;base64'
    });
}

/**
 *
 *
 * @param {object} blob file The file data
 */
export function downloadFile(blob, title, urlLink) {
    try {
        const url = urlLink || (blob ? window.URL.createObjectURL(blob) : null);

        if (!url) {
            throw new Error('No valid blob or URL provided for download');
        }

        // Create a temporary anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = title || 'file.csv';
        a.click();

        // Clean up
        a.remove();
        if (!urlLink && blob) {
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        console.error('Download failed:', error);
    }
}

/**
 *
 *
 * @param {object} Download file from URL
 * filename - String
 * urldata - String
 */
export async function downloadFileFromURL(urldata) {
    try {
        const response = await fetch(urldata);
        if (!response.ok) throw new Error('Network response was not ok');

        const blob = await response.blob();

        // Extract filename from URL
        const urlObj = new URL(urldata);
        const pathname = urlObj.pathname;
        const filename =
            pathname.substring(pathname.lastIndexOf('/') + 1) ?? 'file.csv';

        // Create a temporary object URL
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Clean up
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Download failed:', error);
    }
}

/**
 *
 *
 * @param {elem} create dom elem from props(elemType, className, content)
 */
export function createElemInDom(elemType, className, content, id) {
    var node = document.createElement(elemType);
    node.setAttribute('data-testid', 'error-message');
    node.className = className;
    if (id) {
        node.id = id;
    }
    var textnode = document.createTextNode(content);
    node.appendChild(textnode);
    return node;
}

/**
 *
 *
 * @param {elem} delete dom elem from props(elemID)
 */
export function deleteElemInDom(elemID) {
    if (elemID) {
        var el = document.getElementById(elemID);
        el.innerHTML = '';
    }
}

/**
 *
 *
 * @param {elem} create csv form blob(blobdata)
 */
export function convertBlobToCsv(file) {
    const reader = new FileReader();
    reader.readAsText(file);
    return new Promise((resolve) => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
}

/**
 *
 *
 * @param {str} convert string to first letter uppercase and rest lowercase
 */
export function titleCase(string) {
    if (string) return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

/**
 * Function to return the Subscription type
 *
 * @param - item
 */
export const getPrepValue = (item) => {
    if (item.refundedByVendor) {
        return 'Vendor Refunded';
    }
    if (item.isPrepPlusIncludedFromVendor) {
        if (item.linked) {
            if (
                item.wasPrepPlusRedeemed ||
                (!item.wasPrepPlusRedeemed &&
                    item.prepPlusActivationDate &&
                    item.prepPlusActivationDate < new Date().toISOString())
            ) {
                return 'Redeemed';
            } else {
                return 'Not Redeemed';
            }
        } else {
            return 'Pending';
        }
    } else {
        return 'N/A';
    }
};

/**
 * Function to return the if a input is a number or decimal
 *
 * @param - input
 */
export const IsDecimalOrNumber = (input) => {
    var RE = REGEX.decimalOrNumber;
    return RE.test(input);
};

/**
 * Function to return the boolean if date is lesser then or equal to 30
 *
 * @param - expirationDate - Date-Time string
 */
export const isDateExpiring = (expirationDate) => {
    let remainingDays = getNumberOfDaysBetweenDates(
        new Date(expirationDate),
        new Date()
    );
    return remainingDays <= 30;
};

/**
 * Function to return the number of days, diffrerence between present date and param(setDate) date
 *
 * @param - setDate
 */
export const isDateDifference = (setDate) => {
    let daysCount = getNumberOfDaysBetweenDates(new Date(setDate), new Date());
    if (Math.sign(daysCount) == '-1') {
        daysCount = -1;
    }
    return daysCount;
};

/**
 * Function to return the text message with respect to difference between present date and param(date) date
 *
 * @param - type
 * @param - date
 */
export const getExpirationMessage = (type, date) => {
    let messageType =
        type === 'lsat' ? COMMON.prepPlusSubscription : COMMON.coachingPeriod;
    let getDateDiff = isDateDifference(date);
    if (getDateDiff === 0) {
        return (
            messageType +
            SUBSCRIBER.tooltip.expires +
            SUBSCRIBER.tooltip.today +
            SUBSCRIBER.tooltip.expiry2
        );
    } else if (getDateDiff === 1) {
        return (
            messageType +
            SUBSCRIBER.tooltip.expires +
            SUBSCRIBER.tooltip.tomorrow +
            SUBSCRIBER.tooltip.expiry2
        );
    } else if (getDateDiff === -1) {
        return (
            messageType +
            SUBSCRIBER.tooltip.expired +
            SUBSCRIBER.tooltip.expiry2
        );
    } else {
        return (
            messageType +
            SUBSCRIBER.tooltip.expiry1 +
            isDateDifference(date) +
            SUBSCRIBER.tooltip.days +
            SUBSCRIBER.tooltip.expiry2
        );
    }
};

/**
 *
 *
 * @param {object} jsonObj
 */
export function convertJsonToDatastr(jsonObj) {
    const bytes = new TextEncoder().encode(JSON.stringify(jsonObj));
    const blob = new Blob([bytes], {
        type: 'application/json;charset=utf-8'
    });
    return new Blob([blob], {
        type: 'application/json;charset=utf-8'
    });
}

/**
 * Function to return the boolean, to show/hide resend invite button
 *
 * @param - item - selected student - object
 * @param - vendorRoles - All vendor's vendorId and name - object
 * @param - VendorData -  list of vendorId - Array
 * @param - vendorId - selected vendorId - string
 */
export const shouldDisplayResendInvite = (item, vendorId, vendorRoleInfo) => {
    return (
        (isAdmin(vendorRoleInfo) ||
            checkRolesForNonAdmin(vendorRoleInfo, vendorId)) &&
        !item.linked
    );
};

/**
 * Function to return the identifier value of the LSACOnlineServicesNumber identifierType
 *
 * @param props - selectedStudent (object)
 */
export const displayOrganizationIdentifier = (selectedStudent) => {
    if (
        selectedStudent.organizationIdentifiers &&
        selectedStudent.organizationIdentifiers.length > 0
    ) {
        let indexValue = selectedStudent.organizationIdentifiers.findIndex(
            (value) => {
                return value.identifierType === 'LSACOnlineServicesNumber';
            }
        );
        if (
            indexValue > -1 &&
            selectedStudent.organizationIdentifiers[indexValue].identifier
        ) {
            return selectedStudent.organizationIdentifiers[indexValue]
                .identifier;
        } else {
            return '-';
        }
    } else {
        return '-';
    }
};

/**
 * Function to return the vendor type to be set
 *
 * @param props - vendor list (Array of string)
 */
export const findAndUpdateActiveVendor = (
    roles = [],
    vendorRoles = [],
    vendorId
) => {
    // check with vendorRoles if user is admin else check with user roles
    let isValidVendor = isAdmin(roles)
        ? vendorRoles?.some((role) => role.vendorId === vendorId)
        : roles?.some((role) => role.vendorId === vendorId);

    if (isValidVendor) {
        return vendorId;
    } else if (isAdmin(roles)) {
        return COMMON.admin;
    } else {
        return roles[0]?.vendorId;
    }
};

/**
 * Check productRate has any empty values
 *
 * @param object - Object
 */
export const isObjectValuesAreEmpty = (object) => {
    if (Object.keys(object).length > 0) {
        for (var key in object) {
            if (object[key] === '') {
                return true;
            }
        }
    } else {
        return false;
    }
};

/**
 * Get productId and vendorProductRate from productRate
 *
 * @param object - Object
 */
export const getProductArrayObject = (productRate) => {
    let products = [];
    const keys = Object.keys(productRate);
    for (let i = 0; i < keys.length; i++) {
        products.push({
            productId: keys[i],
            vendorProductRate: productRate[keys[i]]
        });
    }
    return products;
};

/**
 * Create array based on apiAccessValue
 *
 * @param - apiAccessValue - string
 */
export const getApiAccessValue = (apiAccessValue) => {
    if (apiAccessValue && apiAccessValue.length > 0) {
        if (apiAccessValue.includes('None')) {
            return [];
        }
    }
    return apiAccessValue;
};

/* Function to get trimmed value
 *
 * @param value - string
 */
export const getTrimmedValue = (value) => {
    return value && value.trim();
};

/* Function compare two arrays
 *
 * @param value - string
 */
export const compareTwoArrays = (firstArray, secondArray) => {
    return (
        firstArray &&
        secondArray &&
        firstArray.length === secondArray.length &&
        firstArray.every((element_1) =>
            secondArray.some((element_2) => element_1 === element_2)
        )
    );
};

/* Function to check only vendorId from existing roles and send vendor ID other than @currentVendorID
 *
 * @param currentVendorId - string
 * @param vendorData - array
 *
 */
export const getVendorId = (vendorData, currentVendorId) => {
    var newVendorData = vendorData.slice();
    newVendorData.push(
        newVendorData.splice(newVendorData.indexOf(currentVendorId), 1)
    );

    if (newVendorData[0] == 'ADMIN') {
        return newVendorData[1];
    } else {
        return newVendorData[0];
    }
};

/* Function to get product display name from product Id
 *
 * @param productId - string
 * @param productsArray - array
 */
export const getProductDisplayNameFromId = (productId, productsArray) => {
    let productIndex =
        productsArray &&
        productsArray.length > 0 &&
        productsArray.findIndex((product) => product.productId === productId);
    if (productIndex >= 0) {
        return productsArray[productIndex].displayName;
    }
    return productId;
};

/* Function get timezone abbreviation
 *
 * @param date - javascript date object
 */
export function getTimezoneNameAbbr(date) {
    let timeZoneName = String(String(date).split('(')[1]).split(')')[0];
    if (timeZoneName.includes(' ')) {
        const timeZoneNameArr = timeZoneName.split(' ');
        let abbr = '';
        timeZoneNameArr.forEach((value) => {
            abbr += value.charAt(0);
        });
        timeZoneName = abbr;
    }
    return timeZoneName;
}

/* Function to check LSAC-LawReady-Program product
 *
 * @param value - string
 */
export const shouldShowLawReady = (vendorInfo, vendorId) => {
    let index = vendorInfo?.products?.findIndex(
        (product) => product.productId === LAWREADY.productId
    );

    return (
        config.REACT_APP_LAWREADY_FEATURE === 'true' &&
        isNonAdminVendor(vendorId) &&
        index >= 0
    );
};

/* Function to check if product has only Lawready program with current vendor Id
 *
 * @param vendorInfo - object
 * @param vendorId - string
 *
 */
export const vendorHasOnlyLawReadyProduct = (vendorInfo) => {
    if (vendorInfo && vendorInfo.products && vendorInfo.products.length === 1) {
        return vendorInfo.products[0].productId === 'LSAC-LawReady-Program';
    }
    return false;
};

/* Function to check if product has Lawready program or not and product array should have more than one products
 *
 * @param vendorInfo - object
 * @param vendorId - string
 *
 */
export const shouldShowLawReadyFilter = (vendorInfo) => {
    if (vendorInfo && vendorInfo.products && vendorInfo.products.length > 1) {
        let index = vendorInfo.products.findIndex(
            (product) => product.productId === 'LSAC-LawReady-Program'
        );
        return index >= 0;
    }
    return false;
};

/* Function to check if vendor can have permissions to add student
 *
 * @param VendorData - object
 * @param vendorId - string
 *
 */
export const canAddStudent = (vendorRoles, VendorData, vendorId) => {
    if (vendorRoles && vendorRoles.length > 1) {
        return (
            VendorData &&
            VendorData.indexOf(vendorId) > -1 &&
            isNonAdminVendor(vendorId)
        );
    }
    return vendorId;
};

/* Function to compare and update the data
 *
 * @param selectedDataList - array
 * @param fullDataList - array of objects
 *
 */
export const compareAndPushInArr = (selectedDataList, fullDataList) => {
    let dataArray = [];
    selectedDataList &&
        selectedDataList.length > 0 &&
        selectedDataList.forEach((selProds) => {
            fullDataList &&
                fullDataList.length > 0 &&
                fullDataList.forEach((prodData) => {
                    if (selProds == prodData.id) {
                        dataArray.push(prodData);
                    }
                });
        });
    return dataArray;
};

/* Function to compare and update the data
 *
 * @param id - string
 * @param fullDataList - array of objects
 *
 */
export const getVendorNameFromID = (id, vendorList) => {
    const item =
        vendorList &&
        vendorList.length > 0 &&
        vendorList.find(
            (prodData) => prodData.id == id || prodData.productId == id
        );
    return item && (item.displayName ? item.displayName : item.id);
};

/* Function to return updated cost of product
 *
 * @param list - Obj
 * @param type - string
 *
 */
export const getCost = (list, type) => {
    let totalCost = 0;
    list &&
        list.forEach(function (product) {
            if (type == 'both') {
                if (product.id == SUBSCRIBER.lsacPremiumSubscription) {
                    totalCost += parseFloat(product.price);
                }

                if (product.id == SUBSCRIBER.lsacOneyearCoachingLicense) {
                    totalCost += parseFloat(product.price);
                }
            } else if (type == 'coaching') {
                if (product.id == SUBSCRIBER.lsacOneyearCoachingLicense) {
                    totalCost += parseFloat(product.price);
                }
            } else if (type == 'prepPlus') {
                if (product.id == SUBSCRIBER.lsacPremiumSubscription) {
                    totalCost += parseFloat(product.price);
                }
            } else {
            }
        });

    return totalCost;
};

/* Function to set focus on keyboard events
 *
 * @param props - Obj
 * @param event - Obj
 * @param tabIndex - number
 * @param tabRefs - Obj
 *
 */
export const handleKeyDown = (props, event, tabIndex, tabRefs) => {
    const numTabs = tabRefs.current.length;

    if (event.key === COMMON.arrowLeft) {
        event.preventDefault();
        tabRefs.current[(tabIndex + numTabs - 1) % numTabs].focus();
    } else if (event.key === COMMON.arrowRight) {
        event.preventDefault();
        tabRefs.current[(tabIndex + 1) % numTabs].focus();
    } else if (event.key === COMMON.enter) {
        event.preventDefault();
        props.updateCurrentSelectedTab(tabIndex);
    } else if (event.key === COMMON.home) {
        // Handle Home key
        event.preventDefault();
        tabRefs.current[0].focus(); // Go to the first tab
    } else if (event.key === COMMON.end) {
        // Handle End key
        event.preventDefault();
        tabRefs.current[numTabs - 1].focus(); // Go to the last tab
    }
};

/* Function to set focus on tab click
 *
 * @param props - Obj
 * @param tabIndex - number
 *
 */
export const handleTabClick = (props, tabIndex) => {
    props.updateCurrentSelectedTab(tabIndex);
};

/* Function to return updated vendor product rate
 *
 * @param vendorInfo - Obj
 *
 */
export const getVendorInfoWithUpdatedProductRate = (vendorInfo) => {
    let newDataObj = { ...vendorInfo };
    if (newDataObj) {
        newDataObj.products &&
            newDataObj.products.length > 0 &&
            newDataObj.products.map((product) => {
                product.vendorProductRate =
                    product.vendorProductRate *
                    (100).toFixed(2).replace(/\.0+$/, '');
            });
    }
    return newDataObj;
};

/**
 * Function to get selected vendor name through current vendorId
 *
 * @param - props - object
 */
export function getActiveVendorName(vendorRoles, vendorId, uniqueUserRoles) {
    if (isAdmin(uniqueUserRoles)) {
        const getVendorIdIndex = vendorRoles?.findIndex(
            (selectedVendorId) => selectedVendorId.vendorId === vendorId
        );
        if (getVendorIdIndex >= 0) {
            const vendorName =
                vendorRoles && vendorRoles[getVendorIdIndex].vendorName;

            return vendorId && vendorId === COMMON.admin
                ? SUBSCRIBER.allStudents
                : vendorName
                  ? vendorName
                  : SUBSCRIBER.myStudents;
        }
    } else {
        const getVendorIdIndex = uniqueUserRoles?.findIndex(
            (selectedVendorId) => selectedVendorId?.vendorId === vendorId
        );
        if (getVendorIdIndex >= 0) {
            const vendorName = uniqueUserRoles[getVendorIdIndex]?.vendorName;

            return vendorName ?? SUBSCRIBER.myStudents;
        }
    }
}

export function updateAdminVendorRoleToAll(vendorRoles) {
    if (vendorRoles && vendorRoles.length > 0) {
        let index = vendorRoles.findIndex((role) => {
            return role?.vendorId === COMMON.admin;
        });
        if (index !== -1) vendorRoles[index].vendorName = 'All';
    }

    return vendorRoles;
}
/* Function to return vendorId and vendorName from userRoles
 *
 * @param userRoles - Array
 *
 */
export const getVendorIdAndName = (userRoles) => {
    const uniqueVendors = userRoles?.reduce((acc, { vendorId, vendorName }) => {
        if (vendorId !== 'ADMIN') {
            acc[vendorId] = { vendorId, vendorName }; // Store only non-ADMIN roles
        }
        return acc;
    }, {});

    return uniqueVendors ? Object.values(uniqueVendors) : [];
};

export const vendorHasAtleatOneLawReadyProduct = (vendorInfo) => {
    let index =
        vendorInfo &&
        vendorInfo.products &&
        vendorInfo.products.findIndex(
            (product) => product.productId === 'LSAC-LawReady-Program'
        );
    if (index >= 0) {
        return true;
    }

    return false;
};

/* Function to convert string to camelCase
 *
 * @param str - text or string value
 *
 */
export const toCamelCase = (str) => {
    return str.replace(/_([a-z])/g, function (match, letter) {
        return letter.toUpperCase();
    });
};

/* Function to generate error block based on validation rules set
 *
 * @param eList - Array of error field names
 *
 */
export const addChildsInErrorBlock = (eList) => {
    let errorBlock = document.getElementById('error-block');
    createElemInDom('div', '', '');
    if (errorBlock && eList.length > 0) {
        eList.reverse().forEach((key) => {
            errorBlock.appendChild(
                createElemInDom(
                    'div',
                    'input-error',
                    VALIDATION_MESSAGE[toCamelCase(key)],
                    `${key}_error`
                )
            );
        });
    }
};

/* Function to set focus to the element
 *
 * @param id - string
 *
 */
export const setFocusToTheElement = (id) => {
    document.getElementById(id) && document.getElementById(id).focus();
};

/* Function to get test filter names from values
 *
 * @param value - string
 *
 */
export const getTestHistoryFilterNames = (value) => {
    switch (value) {
        case 'All':
            return 'All Prep Test';
        case 'yes':
            return 'Completed Prep Test';
        case 'no':
            return 'In Progress Prep Test';
        default:
            return;
    }
};

/* Function to create API endpoint from value params
 *
 * @param serviceType - string
 * @param apiType - string
 *
 */
export const createEndpoint = (serviceType) => {
    const suffixes = {
        [REDUX_CONSTANT.services.vendorService]:
            configuration.REACT_APP_VENDORS_SUFFIX,
        [REDUX_CONSTANT.services.adminService]:
            configuration.REACT_APP_APIM_SUFFIX,
        [REDUX_CONSTANT.services.offersService]:
            configuration.REACT_APP_OFFERS_SUFFIX,
        [REDUX_CONSTANT.services.configurationService]:
            configuration.REACT_APP_APIM_SUFFIX
    };

    const suffix = suffixes[serviceType] || configuration.REACT_APP_APIM_SUFFIX;

    return config.REACT_APP_APIM_ENDPOINT + suffix;
};

/* Function to create number range
 *
 * @param start - int
 * @param end - int
 *
 */
export const numberRange = (start, end) => {
    return new Array(end - start).fill().map((d, i) => i + start);
};

/* Function to convert decimal to percentage with rounding off
 *
 * @param decimalNumber - number
 * @param toFixedValue - int
 */
export const convertDecimalToPercentage = (decimalNumber, toFixedValue) => {
    return parseFloat(decimalNumber * 100)
        .toFixed(toFixedValue)
        .replace(/\.0+$/, '');
};

/* Function to check admin from roles
 * @param roles - object
 */
export const isAdmin = (roles) => {
    return (
        roles?.some((item) => item.vendorId === COMMON.admin) &&
        config.REACT_APP_FEATURE_ADMIN_ROLE === 'true'
    );
};

/* Function to check vendorId from roles
 * @param roles - object
 * @param vendorId - string
 */
export const checkRolesForNonAdmin = (roles, vendorId) => {
    return (roles ?? []).some((role) => role.vendorId === vendorId);
};
/* Function to check check for LSAC-PlusGuidedJourney product
 *
 * @param vendorInfo - object
 * @param location - object
 * @override - boolean
 */

export const checkLSACPlusGuidedJourney = (
    vendorInfo,
    location,
    override = false
) => {
    const hasPlusGuidedJourney = vendorInfo?.products?.some(
        (product) => product.productId === PLUS_GUIDED_JOURNEY.productId
    );
    if (config.REACT_APP_PLUS_GUIDED_JOURNEY_FEATURE === 'true') {
        if (override) {
            return hasPlusGuidedJourney;
        }

        return (
            !location?.state?.forcefullyRenderLawReady && hasPlusGuidedJourney
        );
    }
    return false;
};

/* Function to navigate with setTimeout
 * @param navigate - function
 * @param path - string
 * @param state - object
 */
export const navigateWithSetTimeout = (navigate, path, state = {}) => {
    setTimeout(() => navigate(path, state), 0);
};

/* Function to get routing precedence based on product
 * @param vendorInfo - object
 * @param vendorId - string
 * @param location - string
 * @param navigate - function
 */
export const getRoutingPrecedenceBasedOnProduct = (
    vendorInfo,
    location,
    navigate,
    vendorIdFromState,
    userRoles,
    vendorRoles
) => {
    const vendorId = vendorInfo?.vendorId;
    if (vendorId !== vendorIdFromState) {
        return;
    }

    const isCurrentVendorIdAdmin = vendorIdFromState === COMMON.admin;

    const hasPlusGuidedJourney =
        !isCurrentVendorIdAdmin &&
        vendorInfo?.products?.some(
            (product) => product.productId === PLUS_GUIDED_JOURNEY.productId
        ) &&
        config.REACT_APP_PLUS_GUIDED_JOURNEY_FEATURE === 'true';
    const hasLawReady =
        !isCurrentVendorIdAdmin &&
        vendorInfo?.products?.some(
            (product) => product.productId === LAWREADY.productId
        ) &&
        config.REACT_APP_LAWREADY_FEATURE === 'true';
    const hasOnlyLawReady =
        !isCurrentVendorIdAdmin &&
        vendorHasOnlyLawReadyProduct(vendorInfo) &&
        config.REACT_APP_LAWREADY_FEATURE === 'true';

    const isOnLawReady = location?.startsWith(Route.LAWREADY);
    const isOnSubscriber = location?.startsWith(Route.SUBSCRIBER);
    let vendorIdFromPath = location?.split('subscriber/')[1];
    let indexForVendorId = isAdmin(userRoles)
        ? vendorRoles?.findIndex((role) => role.vendorId === vendorId)
        : checkRolesForNonAdmin(userRoles, vendorId);
    const checkValidVendor =
        !isCurrentVendorIdAdmin && indexForVendorId > -1 ? true : false;

    const isPageNotFound = vendorIdFromPath === COMMON.admin;

    const padFeatureEnabled = config.REACT_APP_PAD_FEATURE === 'true';
    const hasPad = padFeatureEnabled && vendorHasPadProduct(vendorInfo);
    const isOnPad = location?.startsWith(Route.PAD);

    switch (true) {
        // If currently on PAD and has PAD, stay on PAD
        case isOnPad && hasPad:
            navigateWithSetTimeout(navigate, `${Route.PAD}/${vendorId}`);
            break;

        // If PAD products exists, navigate to SUBSCRIBER
        case hasPad:
            navigateWithSetTimeout(navigate, `${Route.PAD}/${vendorId}`);
            break;

        // If currently on LAWREADY and has LSAC-LawReady-Program, stay on LAWREADY
        case isOnLawReady && hasLawReady:
            navigateWithSetTimeout(navigate, `${Route.LAWREADY}/${vendorId}`);
            break;

        // If currently on SUBSCRIBER and has LSAC-PlusGuidedJourney, stay on SUBSCRIBER
        case isOnSubscriber && hasPlusGuidedJourney:
            navigateWithSetTimeout(navigate, `${Route.PROGRAM}/${vendorId}`);
            break;

        // If LSAC-PlusGuidedJourney exists, navigate to SUBSCRIBER
        case hasPlusGuidedJourney:
            navigateWithSetTimeout(navigate, `${Route.PROGRAM}/${vendorId}`);
            break;

        // If LSAC-LawReady-Program exists, navigate to LAWREADY
        case hasOnlyLawReady:
            navigateWithSetTimeout(navigate, `${Route.LAWREADY}/${vendorId}`);
            break;

        case isCurrentVendorIdAdmin:
            !location?.startsWith(Route.ADMIN) &&
                navigateWithSetTimeout(navigate, Route.ADMIN);
            break;

        case isPageNotFound:
            navigateWithSetTimeout(navigate, Route.PAGE_NOT_FOUND);
            break;

        case checkValidVendor:
            !isCurrentVendorIdAdmin &&
                navigateWithSetTimeout(
                    navigate,
                    `${Route.SUBSCRIBER}/${vendorId}`
                );
            break;

        // Default: Navigate to SUBSCRIBER if neither product exists
        default:
            navigateWithSetTimeout(navigate, Route.PAGE_NOT_FOUND);
            break;
    }
};

/* Function to check if vendor is eligible for student summary view
 * @param vendorInfo - object
 * @param location - object
 */
export const isVendorisEligibleforStudentSummaryView = (
    vendorInfo,
    location
) => {
    const padFeatureEnabled = config.REACT_APP_PAD_FEATURE === 'true';
    return (
        checkLSACPlusGuidedJourney(vendorInfo, location) ||
        location?.pathname?.startsWith(Route.LAWREADY) ||
        vendorHasOnlyLawReadyProduct(vendorInfo) ||
        (padFeatureEnabled && vendorHasPadProduct(vendorInfo))
    );
};

/* Function to check vendorName from roles
 * @param roles - object
 * @param vendorName - string
 */
export const checkVendorNameFromRole = (roles, vendorName) => {
    return roles?.some((role) => role.vendorName === vendorName);
};

/* Function to check reponse contains error status code
 * @param response - object
 */
export const checkForAllErrorStatusCode = (response) => {
    return COMMON.errorCodes.includes(response?.statusCode);
};

/**
 * Function to return route based on data
 *
 * @param props - Object
 */
export const getRedirectionPath = (props) => {
    if (isAdmin(props.vendorRoleInfo?.userRoles)) {
        props.updateVendorId(COMMON.admin);
        return RoutePath.ADMIN;
    } else if (vendorHasOnlyLawReadyProduct(props.vendorInfo)) {
        return RoutePath.LAWREADY + '/' + props.vendorInfo.vendorId;
    }
    return RoutePath.SUBSCRIBER;
};

/**
 * Function to check if the user is from URL
 *
 * @param props - pathname - string
 */
export function isUserFromUrl(pathname) {
    return REGEX.userPath.test(pathname);
}

/**
 * Function to check if the vendorId is non admin
 *
 * @param vendorId - string
 */
export const isNonAdminVendor = (vendorId) => {
    return vendorId && vendorId !== COMMON.admin;
};

/* Function to check vendor has any PAD products
 * @param vendorInfo - object
 */
export const vendorHasPadProduct = (vendorInfo) => {
    return (
        (vendorInfo?.products?.some((product) =>
            config.REACT_APP_PAD_PRODUCT_IDS?.includes(product.productId)
        ) &&
            config.REACT_APP_PAD_FEATURE === 'true') ||
        false
    );
};

/**
 * Helper function to get product ID and rate display
 * @param {string} displayName - Product display name
 * @param {string} productId - Product ID
 * @param {string} price - Product price
 * @returns {string} - Formatted product display string
 */
export const getProductIdAndRate = (displayName, productId, price) => {
    if (price === undefined || price === null) {
        return displayName ? displayName : productId;
    }
    return `${displayName ? displayName : productId} : $${price}`;
};

/**
 * Helper function to find product ID and rate
 * @param {string} selectedProduct - Selected product ID
 * @param {array} productListData - Product list data
 * @returns {string} - Formatted product display string
 */
export const findProductIdAndRate = (selectedProduct, productListData) => {
    let index = productListData.findIndex(
        (product) => product.id === selectedProduct
    );
    if (index > -1) {
        return getProductIdAndRate(
            productListData[index].displayName,
            productListData[index].id,
            productListData[index].price
        );
    }
};

/**
 * Function to return vendor type
 * @param {string} vendorType - Contains vendor type
 * @returns {string} - Formatted vendor type
 */
export const getVendorType = (vendorType) => {
    return vendorType === 'Non-Profit' ? 'Non Profit' : 'Profit';
};

/**
 * Function to check product associated and rate of product are updated or not
 * @param {object} productRate - productRate - rate of product
 * @param {object} selectedVendorForUpdate - selected vendor information to update
 * @returns {boolean} - Whether products are updated
 */
export const getProductsArray = (productRate, selectedVendorForUpdate) => {
    let products = getProductArrayObject(productRate);
    if (selectedVendorForUpdate?.products?.length === products.length) {
        let uniqueResultArrayObjOne = selectedVendorForUpdate.products.filter(
            function (objOne) {
                return !products.some(function (objTwo) {
                    return (
                        objOne.productId == objTwo.productId &&
                        convertDecimalToPercentage(
                            objOne.vendorProductRate,
                            6
                        ) == objTwo.vendorProductRate
                    );
                });
            }
        );
        return uniqueResultArrayObjOne.length == 0;
    }
    return false;
};

/**
 * Function to check allowed offer products and max offer counts are updated or not
 * @param {object} params - Parameters object
 * @param {boolean} params.noneSelected - Whether none is selected
 * @param {string} params.offerQuantityValidation - Offer quantity validation value
 * @param {array} params.offerProductCheckedArray - Offer product checked array
 * @param {object} params.selectedVendorForUpdate - Selected vendor for update
 * @returns {boolean} - Whether offer products are updated
 */
export const checkOfferProductCheckedArray = (params) => {
    const {
        noneSelected,
        offerQuantityValidation,
        offerProductCheckedArray,
        selectedVendorForUpdate
    } = params;
    if (!noneSelected) {
        return (
            selectedVendorForUpdate?.maxOfferCount ===
                parseInt(offerQuantityValidation) &&
            selectedVendorForUpdate?.allowedProductsForOffers?.length ===
                offerProductCheckedArray?.length &&
            selectedVendorForUpdate?.allowedProductsForOffers.every(
                (element_1) =>
                    offerProductCheckedArray.some(
                        (element_2) =>
                            element_1.productId === element_2.productId
                    )
            )
        );
    }
    return (
        selectedVendorForUpdate?.allowedProductsForOffers?.length === 0 &&
        noneSelected
    );
};

/**
 * Function to handle validating all the fields
 * @param {string} type - Contains current step
 * @param {object} data - Data object containing all form values
 * @returns {boolean} - Whether all data is filled
 */
export const doesAllAddVendorDataFilled = (type, data) => {
    if (type === 'vendorIdentity') {
        return (
            // explicitly check for empty string
            data.formData?.vendorName !== '' &&
            data.formData?.vendorName?.toLowerCase()?.match(REGEX.name) &&
            data.formData?.vendorId !== '' &&
            data.formData.vendorId?.toLowerCase()?.match(REGEX.name) &&
            data.vendorTypeFromInput !== ''
        );
    } else if (type === 'configuration') {
        return (
            data.checkedProductArray?.length > 0 &&
            Object.keys(data.productRate)?.length > 0 &&
            data.checkedProductArray.length ===
                Object.keys(data.productRate)?.length &&
            !isObjectValuesAreEmpty(data.productRate)
        );
    } else if (type === 'permissions') {
        if (data.apiAccessValue?.length > 0 && data.resourceValue?.length > 0) {
            if (
                data.offerQuantityValidation &&
                data.offerQuantityValidation !== '' &&
                data.offerQuantityValidation > 0 &&
                data.offerQuantityValidation !== '0'
            ) {
                return true;
            } else {
                return data.noneSelected;
            }
        }
        return false;
    } else if (type === 'marketplaceInfo') {
        return (
            data.websiteFromInput &&
            data.websiteFromInput !== '' &&
            data.descriptionFromInput &&
            data.descriptionFromInput !== '' &&
            data.imageData &&
            data.imageData !== ''
        );
    }
};

/**
 * Function to compare marketplace info data
 * @param {object} data - Data object containing marketplace info
 * @param {object} selectedVendorForUpdate - Selected vendor for update
 * @returns {boolean} - Whether marketplace info has changed
 */
export const compareMarketplaceInfoData = (data, selectedVendorForUpdate) => {
    return (
        data.enableFlagVendor !== selectedVendorForUpdate?.isPublic ||
        data.websiteFromInput !== selectedVendorForUpdate?.website ||
        data.descriptionFromInput !== selectedVendorForUpdate?.description ||
        data.imageData !== selectedVendorForUpdate?.imageUrl ||
        data.feeWaiverDiscountValue !== selectedVendorForUpdate?.offersFeeWaiver
    );
};

/**
 * Function to check if vendor data is updated or not
 * @param {object} data - Data object containing all form values
 * @param {object} selectedVendorForUpdate - Selected vendor for update
 * @returns {boolean} - Whether vendor data has been updated
 */
export const doesVendordataUpdated = (data, selectedVendorForUpdate) => {
    if (doesAllAddVendorDataFilled('permissions', data)) {
        if (
            data.formData?.vendorName !== selectedVendorForUpdate?.vendorName ||
            data.vendorTypeFromInput !==
                getVendorType(selectedVendorForUpdate?.vendorType) ||
            !getProductsArray(data.productRate, selectedVendorForUpdate) ||
            !compareTwoArrays(
                selectedVendorForUpdate?.apiAccessEnabledFor?.length > 0
                    ? selectedVendorForUpdate.apiAccessEnabledFor
                    : ['None'],
                data.apiAccessValue && data.apiAccessValue.includes('None')
                    ? ['None']
                    : data.apiAccessValue
            ) ||
            !checkOfferProductCheckedArray({
                noneSelected: data.noneSelected,
                offerQuantityValidation: data.offerQuantityValidation,
                offerProductCheckedArray: data.offerProductCheckedArray,
                selectedVendorForUpdate
            }) ||
            // Check if Resource Available to Vendor has changed
            (data.resourceValue &&
                (data.resourceValue.includes(VENDOR.licenseeMark) !==
                    !!selectedVendorForUpdate?.contractSigned ||
                    data.resourceValue.includes(VENDOR.bulkUpload) !==
                        !!selectedVendorForUpdate?.allowBulkUpload)) ||
            (config.REACT_APP_MARKETPLACE_FLAGGED_FEATURE === 'true' &&
                compareMarketplaceInfoData(data, selectedVendorForUpdate))
        ) {
            return true;
        }
        return false;
    }
};

export const getResourceAvailabilityText = (addNewVendorAllDataObj) => {
    const { allowBulkUpload, contractSigned } = addNewVendorAllDataObj || {};

    if (allowBulkUpload && contractSigned) {
        return `${VENDOR.licenseeMark}, ${VENDOR.bulkUpload}`;
    }

    if (contractSigned) {
        return VENDOR.licenseeMark;
    }

    if (allowBulkUpload) {
        return VENDOR.bulkUpload;
    }

    return VENDOR.none;
};
/**
 * Downloads a file from a cross-origin URL by fetching it as a blob first
 * and triggering a same-origin anchor click — avoids browser page navigation.
 *
 * Use this instead of downloadFileFromURL when you need to supply a custom
 * filename (e.g. from an API response) and want the download to stay on the
 * same page without the browser navigating away.
 * @param {string} urldata    - The remote presigned/direct URL to fetch
 * @param {string} [filename] - Optional custom filename.
 */
export async function downloadFileFromDirectURL(urldata, filename) {
    try {
        const response = await fetch(urldata);
        if (!response.ok) throw new Error('Network response was not ok');

        const blob = await response.blob();

        // Create a same-origin blob URL so the anchor click is a download,
        // not a cross-origin navigation that blanks the page.
        const objectUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(objectUrl);
        return true;
    } catch (error) {
        console.error('Download failed:', error);
        return false;
    }
}
